module.exports = __webpack_public_path__ + "img/slider_9.2f066d72.jpg";